import { colorPrimary } from './colorPrimary';

export const colorSemantic = {
  /// BACKGROUNDS /////

  // Neutral dark backgrounds
  colorBgNdStrong: colorPrimary.nd500,
  colorBgNdBase: colorPrimary.nd400,
  colorBgNdWeak: colorPrimary.nd300,
  colorBgNdWeaker: colorPrimary.nd200,

  // Neutral light backgrounds
  colorBgNlStrongest: colorPrimary.nl500,
  colorBgNlStronger: colorPrimary.nl400,
  colorBgNlStrong: colorPrimary.nl300,
  colorBgNlBase: colorPrimary.nl200,
  colorBgNlWeak: colorPrimary.nl100,
  colorBgNlWeaker: colorPrimary.nl0,

  // Brand backgrounds
  colorBgBrandStronger: colorPrimary.lime400,
  colorBgBrandStrong: colorPrimary.lime300,
  colorBgBrandBase: colorPrimary.lime200,
  colorBgBrandWeak: colorPrimary.lime100,

  // Brand secondary backgrounds
  colorBgBrandSecondaryStrong: colorPrimary.purple400,
  colorBgBrandSecondaryBase: colorPrimary.purple300,
  colorBgBrandSecondaryWeak: colorPrimary.purple200,
  colorBgBrandSecondaryWeaker: colorPrimary.purple100,

  // Info backgrounds
  colorBgInfoBase: colorPrimary.blue400,
  colorBgInfoWeak: colorPrimary.blue300,
  colorBgInfoWeaker: colorPrimary.blue200,
  colorBgInfoWeakest: colorPrimary.blue100,

  // Success backgrounds
  colorBgSuccessStrong: colorPrimary.teal400,
  colorBgSuccessBase: colorPrimary.teal300,
  colorBgSuccessWeak: colorPrimary.teal200,
  colorBgSuccessWeaker: colorPrimary.teal100,

  // Warning backgrounds
  colorBgWarningBase: colorPrimary.yellow300,
  colorBgWarningWeak: colorPrimary.yellow100,

  // Error backgrounds
  colorBgErrorStrong: colorPrimary.red300,
  colorBgErrorBase: colorPrimary.red200,
  colorBgErrorWeak: colorPrimary.red100,

  // Teal backgrounds
  colorBgTealStronger: colorPrimary.teal400,
  colorBgTealStrong: colorPrimary.teal300,
  colorBgTealBase: colorPrimary.teal200,
  colorBgTealWeak: colorPrimary.teal100,

  /// BORDERS /////

  // Neutral dark borders
  colorBorderNdStronger: colorPrimary.nd500,
  colorBorderNdStrong: colorPrimary.nl500,
  colorBorderNdBase: colorPrimary.nl400,
  colorBorderNdWeak: colorPrimary.nl300,
  colorBorderNdWeaker: colorPrimary.nl0,

  // Neutral light borders
  colorBorderNlStrong: colorPrimary.nd300,
  colorBorderNlBase: colorPrimary.nd200,
  colorBorderNlWeak: colorPrimary.nl0,

  // Brand borders
  colorBorderBrandStrong: colorPrimary.lime400,
  colorBorderBrandBase: colorPrimary.lime300,
  colorBorderBrandWeak: colorPrimary.lime200,

  // Brand secondary borders
  colorBorderBrandSecondaryBase: colorPrimary.purple400,
  colorBorderBrandSecondaryWeak: colorPrimary.purple200,

  // Info borders
  colorBorderInfoBase: colorPrimary.blue400,
  colorBorderInfoWeak: colorPrimary.blue300,
  colorBorderInfoWeaker: colorPrimary.blue200,

  // Warning borders
  colorBorderWarningBase: colorPrimary.yellow400,

  // Error borders
  colorBorderErrorStrong: colorPrimary.red500,
  colorBorderErrorBase: colorPrimary.red400,
  colorBorderErrorWeak: colorPrimary.red200,

  // Teal borders
  colorBorderTealStrong: colorPrimary.teal400,
  colorBorderTealBase: colorPrimary.teal200,
  colorBorderTealWeak: colorPrimary.teal100,

  /// TEXT /////

  // Neutral dark text
  colorTextNdPrimary: colorPrimary.nd500,
  colorTextNdSecondary: colorPrimary.nd400,
  colorTextNdTernary: colorPrimary.nd200,
  colorTextNdDisabled: colorPrimary.nd100,

  // Neutral light text
  colorTextNlPrimary: colorPrimary.nl0,
  colorTextNlSecondary: colorPrimary.nl400,
  colorTextNlTernary: colorPrimary.nl500,
  colorTextNlDisabled: colorPrimary.nd200,

  // Brand text
  colorTextBrandStronger: colorPrimary.lime400,
  colorTextBrandStrong: colorPrimary.lime300,
  colorTextBrandBase: colorPrimary.lime200,

  // Brand secondary text
  colorTextBrandSecondaryBase: colorPrimary.purple500,
  colorTextBrandSecondaryWeak: colorPrimary.purple200,

  // Info text
  colorTextInfoStrong: colorPrimary.blue500,
  colorTextInfoBase: colorPrimary.blue400,
  colorTextInfoWeaker: colorPrimary.blue200,

  // Info inverse text
  colorTextInfoInverseBase: colorPrimary.cyan200,

  // Success text
  colorTextSuccessStrong: colorPrimary.teal400,
  colorTextSuccessBase: colorPrimary.teal300,
  colorTextSuccessWeak: colorPrimary.teal200,

  // Warning text
  colorTextWarningStrong: colorPrimary.yellow500,
  colorTextWarningBase: colorPrimary.yellow400,

  // Error text
  colorTextErrorStrong: colorPrimary.red500,
  colorTextErrorBase: colorPrimary.red400,
  colorTextErrorWeak: colorPrimary.red200,

  /// ICONS /////

  // Neutral dark icons
  colorIconNdPrimary: colorPrimary.nd300,
  colorIconNdSecondary: colorPrimary.nd100,
  colorIconNdDisabled: colorPrimary.nl500,

  // Neutral light icons
  colorIconNlPrimary: colorPrimary.nl0,
  colorIconNlDisabled: colorPrimary.nl100,

  // Brand icons
  colorIconBrandStrong: colorPrimary.lime400,
  colorIconBrandBase: colorPrimary.lime200,

  // Brand secondary icons
  colorIconBrandSecondaryBase: colorPrimary.purple400,

  // Info icons
  colorIconInfoBase: colorPrimary.blue500,
  colorIconInfoWeak: colorPrimary.blue300,
  colorIconInfoWeaker: colorPrimary.blue200,

  // Info inverse icons
  colorIconInfoInverseBase: colorPrimary.cyan200,

  // Success icons
  colorIconSuccessBase: colorPrimary.teal400,
  colorIconSuccessWeakest: colorPrimary.teal100,

  // Warning icons
  colorIconWarningBase: colorPrimary.yellow400,
  colorIconWarningWeak: colorPrimary.yellow300,

  // Error icons
  colorIconErrorStrong: colorPrimary.red400,
  colorIconErrorBase: colorPrimary.red200,
} as const;

export type ColorSemanticKey = keyof typeof colorSemantic;
